/**
 * Loading page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var app    = require('mag-app'),
    keys   = require('stb-keys'),

    Page   = require('stb-component-page'),
    Button = require('stb-component-button'),

    FakeInput  = require('../components/fake.input'),

    page          = new Page({$node: document.getElementById('pageLogin')}),

    $plLabelError = document.getElementById('plLabelError'),

    requestCallback = null,

    inputLogin,
    buttonSubmit,
    inputPassword;


inputLogin    = new FakeInput({
    $node: window.plInputLogin,
    placeholder: gettext('Login'),
    events: {
        keydown: function ( event ) {
            FakeInput.defaultEvents.keydown.call(this, event);

            switch ( event.code ) {
                case keys.down:
                    inputPassword.focus();
                    break;

                default:
                    break;
            }
        }
    }
});

buttonSubmit  = new Button({
    $node: window.plButtonSubmit,
    value: gettext('Sign in')
});

inputPassword = new FakeInput({
    $node: window.plInputPassword,
    placeholder: gettext('Password'),
    type: 'password',
    events: {
        keydown: function ( event ) {
            FakeInput.defaultEvents.keydown.call(this, event);

            switch ( event.code ) {
                case keys.down:
                    buttonSubmit.focus();
                    break;

                case keys.up:
                    inputLogin.focus();
                    break;

                default:
                    break;
            }
        }
    }
});
// buttonSubmit.$node.classList.remove('stb-component-button');
// buttonSubmit.$node.classList.add('theme-focus');
// buttonSubmit.$node.classList.add('my-component-button');
// inputLogin.$node.classList.add('theme-main');
// inputLogin.$node.classList.add('theme-border');
// inputPassword.$node.classList.add('theme-main');
// page.$node.classList.add('theme-background-color');
inputLogin.title = gettext('Enter login');
inputPassword.title = gettext('Enter password');

app.stalker.oncredenitalsrequired = function ( callback, config ) {
    var backend = require('../modules/shared.backend').instance;

    backend.withCredentials = true;

    if ( PLATFORM === 'MAG' ) {
        requestCallback = callback;
    } else {
        requestCallback = function () {
            // reload required for all platforms after login
            if ( callback ) {
                callback();
            } else {
                parent.location.reload();
            }
        };
    }

    if ( config ) {
        switch ( config.error.error_description ) {
            case  'Account disabled':
                if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
                    app.route(app.pages.accountDisabled);
                } else {
                    $plLabelError.innerText = gettext('Account disabled');
                    $plLabelError.className = 'visible';
                }
                break;

            default:
                $plLabelError.innerText = gettext(config.error.error_description);
                $plLabelError.className = 'visible';
                break;
        }

        if ( TARGET !== 'android-stb' || TARGET !== 'android-app' ) {
            // app.route(app.pages.accountDisabled) - called
            inputLogin.focus();
        }
    }

    core.taskManager.setLauncher(window);
    core.taskManager.hideAll();
};

page.addListener('show', function () {
    inputLogin.focus();
});

buttonSubmit.addListener('keydown', function ( event ) {
    if ( event.code === keys.up ) {
        inputPassword.focus();
    }/* else if ( event.code === keys.down ) {
        buttonExit.focus();
    }*/
});

buttonSubmit.addListener('click', function () {
    // reset style
    $plLabelError.className = '';

    if ( inputLogin.value.length === 0 ) {
        // empty login
        $plLabelError.innerText = gettext('Error.') + ' ' + gettext('Please, input login');
        $plLabelError.className = 'visible';
        inputLogin.focus();
    } else if ( inputPassword.value.length === 0 ) {
        // empty password
        $plLabelError.innerText = gettext('Error.') + ' ' + gettext('Please, input password');
        $plLabelError.className = 'visible';
        inputPassword.focus();
    } else {
        app.stalker.auth.login({
            password: inputPassword.value,
            login: inputLogin.value
        }, function ( error, response ) {
            if ( error ) {
                if ( response.error_description ) {
                    $plLabelError.innerText = gettext(response.error_description);
                    $plLabelError.className = 'visible';
                    inputLogin.focus();
                } else {
                    $plLabelError.innerText = gettext(response.error_description);
                    $plLabelError.className = 'visible';
                    inputLogin.focus();
                }
            } else {
                core.call('hide');
                core.call('blur');
                if ( requestCallback ) {
                    requestCallback();
                    requestCallback = null;
                } else {
                    console.log('oncredenitalsrequired');
                    core.events.show = null;
                    core.emit('ready', {stop: false});
                }
            }
        });
    }
});


// public
module.exports = page;
